import Vue from 'vue'
import Agency from './Agency.vue'
import AgencyApi from './AgencyApi.vue'
import AgencyHistory from './AgencyHistory.vue'
import AgencyFinances from './AgencyFinances.vue'
import AgencyRelationship from './AgencyRelationship'

const AgencyComponent = Vue.extend(Agency)
const AgencyApiComponent = Vue.extend(AgencyApi)
const AgencyHistoryComponent = Vue.extend(AgencyHistory)
const AgencyFinancesComponent = Vue.extend(AgencyFinances)
const AgencyRelationshipComponent = Vue.extend(AgencyRelationship)
export default {
  openAgency (propsData) {
    return new AgencyComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openAgencyApi (propsData) {
    return new AgencyApiComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openAgencyHistory (propsData) {
    return new AgencyHistoryComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openAgencyFinances (propsData) {
    return new AgencyFinancesComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openAgencyRelationship (propsData) {
    return new AgencyRelationshipComponent({
      el: document.createElement('div'),
      propsData
    })
  }
}



// WEBPACK FOOTER //
// ./client/components/agencies/agency.js